"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE = void 0;
// Do not edit manually!!
// When editing, edit template2 database
// It is generated automatically when you run jenkins job

const CODE = exports.CODE = {
  /**
   * 権限制御業務内容コード：auth_gyomu_cd
   */
  AUTH_GYOMU_CD: {
    /** 権限制御業務内容コード */
    KBN: 'auth_gyomu_cd',
    /** 権限制御業務内容コード：担当未登録 */
    CODE_0: '0',
    /** 権限制御業務内容コード：監査部門 */
    CODE_1: '1',
    /** 権限制御業務内容コード：被監査部門 */
    CODE_2: '2',
    /** 権限制御業務内容コード：監査部門および被監査部門 */
    CODE_3: '3'
  },
  /**
   * 権限制御ユーザ属性：auth_user_prop
   */
  AUTH_USER_PROP: {
    /** 権限制御ユーザ属性 */
    KBN: 'auth_user_prop',
    /** 権限制御ユーザ属性：規定値（デフォルト） */
    CODE_DEFAULT: 'default',
    /** 権限制御ユーザ属性：親会社 */
    CODE_PARENT: 'parent',
    /** 権限制御ユーザ属性：親会社かつM以上 */
    CODE_PARENT_OVER_M: 'parent_over_m',
    /** 権限制御ユーザ属性：親会社かつS以下 */
    CODE_PARENT_UNDER_S: 'parent_under_s',
    /** 権限制御ユーザ属性：子会社 */
    CODE_CHILD: 'child',
    /** 権限制御ユーザ属性：子会社かつM以上 */
    CODE_CHILD_OVER_M: 'child_over_m',
    /** 権限制御ユーザ属性：子会社かつS以下 */
    CODE_CHILD_UNDER_S: 'child_under_s',
    /** 権限制御ユーザ属性：M以上 */
    CODE_OVER_M: 'over_m',
    /** 権限制御ユーザ属性：S以下 */
    CODE_UNDER_S: 'under_s',
    /** 権限制御ユーザ属性：画面から登録されたユーザ */
    CODE_GAMEN_REG_USER: 'gamen_reg_user',
    /** 権限制御ユーザ属性：認証未加入会社（画面から登録された会社） */
    CODE_GAMEN_REG_KAISHA: 'gamen_reg_kaisha',
    /** 権限制御ユーザ属性：混在会社（認証加入会社かつ画面からユーザ登録ができる会社） */
    CODE_MIX_KAISHA: 'mix_kaisha'
  },
  /**
   * 自動取込種別：auto_import_kind
   */
  AUTO_IMPORT_KIND: {
    /** 自動取込種別 */
    KBN: 'auto_import_kind',
    /** 自動取込種別：地震 */
    CODE_1: '1',
    /** 自動取込種別：気象警報 */
    CODE_2: '2',
    /** 自動取込種別：噴火警報 */
    CODE_3: '3'
  },
  /**
   * 基礎加点区分コード：base_debit_cd
   */
  BASE_DEBIT_CD: {
    /** 基礎加点区分コード */
    KBN: 'base_debit_cd',
    /** 基礎加点区分コード：基礎 */
    CODE_1: '1',
    /** 基礎加点区分コード：加点 */
    CODE_2: '2'
  },
  /**
   * 訓練実施要領データ区分コード：bcm_kj_data_kbn
   */
  BCM_KJ_DATA_KBN: {
    /** 訓練実施要領データ区分コード */
    KBN: 'bcm_kj_data_kbn',
    /** 訓練実施要領データ区分コード：対象リスク */
    CODE_01: '01',
    /** 訓練実施要領データ区分コード：訓練時期 */
    CODE_02: '02'
  },
  /**
   * グループID：bcm_kr_group
   */
  BCM_KR_GROUP: {
    /** グループID */
    KBN: 'bcm_kr_group',
    /** グループID：risk01 */
    CODE_1: '1',
    /** グループID：risk02 */
    CODE_2: '2'
  },
  /**
   * 訓練進捗状況コード：bcm_kr_prog_cd
   */
  BCM_KR_PROG_CD: {
    /** 訓練進捗状況コード */
    KBN: 'bcm_kr_prog_cd',
    /** 訓練進捗状況コード：未登録 */
    CODE_0: '0',
    /** 訓練進捗状況コード：登録済 */
    CODE_1: '1',
    /** 訓練進捗状況コード：作成中 */
    CODE_2: '2'
  },
  /**
   * シナリオ方針コード：bcm_scenario
   */
  BCM_SCENARIO: {
    /** シナリオ方針コード */
    KBN: 'bcm_scenario',
    /** シナリオ方針コード：ＮＥＣ中央のシナリオに従い訓練する */
    CODE_01: '01',
    /** シナリオ方針コード：各社／各NEC関係部門共通のシナリオで訓練する */
    CODE_02: '02',
    /** シナリオ方針コード：部門独自のシナリオで訓練する */
    CODE_03: '03'
  },
  /**
   * Biz_アクセス権限：biz_access_auth
   */
  BIZ_ACCESS_AUTH: {
    /** Biz_アクセス権限 */
    KBN: 'biz_access_auth',
    /** Biz_アクセス権限：一般 */
    CODE_1: '1',
    /** Biz_アクセス権限：全社管理者 */
    CODE_5: '5',
    /** Biz_アクセス権限：1st組織管理者 */
    CODE_4: '4',
    /** Biz_アクセス権限：2nd組織管理者 */
    CODE_3: '3',
    /** Biz_アクセス権限：3rd組織管理者 */
    CODE_2: '2',
    /** Biz_アクセス権限：4th組織管理者 */
    CODE_B: 'b',
    /** Biz_アクセス権限：5th組織管理者 */
    CODE_C: 'c',
    /** Biz_アクセス権限：6th組織管理者 */
    CODE_F: 'f',
    /** Biz_アクセス権限：7th組織管理者 */
    CODE_G: 'g',
    /** Biz_アクセス権限：8th組織管理者 */
    CODE_H: 'h',
    /** Biz_アクセス権限：9th組織管理者 */
    CODE_I: 'i',
    /** Biz_アクセス権限：10th組織管理者 */
    CODE_J: 'j'
  },
  /**
   * Biz_ユーザ設定コード：biz_customer_cd
   */
  BIZ_CUSTOMER_CD: {
    /** Biz_ユーザ設定コード */
    KBN: 'biz_customer_cd',
    /** Biz_ユーザ設定コード：社員＋在職中＋出向中 */
    CODE_1: '1',
    /** Biz_ユーザ設定コード：社員＋在職中＋出向中ではない */
    CODE_2: '2',
    /** Biz_ユーザ設定コード：社員＋休職中 */
    CODE_3: '3',
    /** Biz_ユーザ設定コード：構内作業者 */
    CODE_4: '4'
  },
  /**
   * 建物オーナー区分：building_owner_kbn
   */
  BUILDING_OWNER_KBN: {
    /** 建物オーナー区分 */
    KBN: 'building_owner_kbn',
    /** 建物オーナー区分：ＮＥＣグループ保有 */
    CODE_1: '1',
    /** 建物オーナー区分：その他 */
    CODE_2: '2'
  },
  /**
   * 災害種別：disaster_kind
   */
  DISASTER_KIND: {
    /** 災害種別 */
    KBN: 'disaster_kind',
    /** 災害種別：地震 */
    CODE_10: '10',
    /** 災害種別：その他 */
    CODE_90: '90'
  },
  /**
   * 災害レベル：disaster_lv
   */
  DISASTER_LV: {
    /** 災害レベル */
    KBN: 'disaster_lv',
    /** 災害レベル：レベル１ */
    CODE_1: '1',
    /** 災害レベル：レベル２ */
    CODE_2: '2',
    /** 災害レベル：レベル３ */
    CODE_3: '3',
    /** 災害レベル：レベル０ */
    CODE_0: '0',
    /** 災害レベル：属性：1 */
    ATTR_1: '1',
    /** 災害レベル：属性：0 */
    ATTR_0: '0'
  },
  /**
   * ドキュメント種別コード：document_kind
   */
  DOCUMENT_KIND: {
    /** ドキュメント種別コード */
    KBN: 'document_kind',
    /** ドキュメント種別コード：訓練中期計画 */
    CODE_KCK: 'KCK',
    /** ドキュメント種別コード：訓練実施報告 */
    CODE_KJH: 'KJH',
    /** ドキュメント種別コード：訓練補足資料 */
    CODE_KJK: 'KJK',
    /** ドキュメント種別コード：訓練実施要領 */
    CODE_KJY: 'KJY'
  },
  /**
   * FAQ区分：faq_kbn
   */
  FAQ_KBN: {
    /** FAQ区分 */
    KBN: 'faq_kbn',
    /** FAQ区分：FAQ */
    CODE_0: '0',
    /** FAQ区分：サイトマップ */
    CODE_1: '1'
  },
  /**
   * フラグ値：flg_value
   */
  FLG_VALUE: {
    /** フラグ値 */
    KBN: 'flg_value',
    /** フラグ値：オン */
    CODE_1: '1',
    /** フラグ値：オフ */
    CODE_0: '0'
  },
  /**
   * 文字サイズコード：fontsize_cd
   */
  FONTSIZE_CD: {
    /** 文字サイズコード */
    KBN: 'fontsize_cd',
    /** 文字サイズコード：標準 */
    CODE_0: '0',
    /** 文字サイズコード：大きい */
    CODE_1: '1'
  },
  /**
   * 一般ユーザ公開フラグ：general_public_flg
   */
  GENERAL_PUBLIC_FLG: {
    /** 一般ユーザ公開フラグ */
    KBN: 'general_public_flg',
    /** 一般ユーザ公開フラグ：公開する */
    CODE_1: '1',
    /** 一般ユーザ公開フラグ：公開しない */
    CODE_0: '0'
  },
  /**
   * グループ区分：group_kbn
   */
  GROUP_KBN: {
    /** グループ区分 */
    KBN: 'group_kbn',
    /** グループ区分：ユーザグループ */
    CODE_0: '0',
    /** グループ区分：組織グループ */
    CODE_1: '1'
  },
  /**
   * グループの役割：group_roles
   */
  GROUP_ROLES: {
    /** グループの役割 */
    KBN: 'group_roles',
    /** グループの役割：管理者 */
    CODE_1: '1',
    /** グループの役割：管理者／メンバ */
    CODE_2: '2',
    /** グループの役割：メンバ */
    CODE_3: '3'
  },
  /**
   * 被災レベルコード：hisai_level_cd
   */
  HISAI_LEVEL_CD: {
    /** 被災レベルコード */
    KBN: 'hisai_level_cd',
    /** 被災レベルコード：大 */
    CODE_3: '3',
    /** 被災レベルコード：小 */
    CODE_2: '2',
    /** 被災レベルコード：被災無し */
    CODE_1: '1',
    /** 被災レベルコード：調査中 */
    CODE_0: '0'
  },
  /**
   * 法人区分コード：hojin_cd
   */
  HOJIN_CD: {
    /** 法人区分コード */
    KBN: 'hojin_cd',
    /** 法人区分コード：国内法人 */
    CODE_1: '1',
    /** 法人区分コード：海外法人 */
    CODE_2: '2'
  },
  /**
   * 通信手段：inhit_communication_means
   */
  INHIT_COMMUNICATION_MEANS: {
    /** 通信手段 */
    KBN: 'inhit_communication_means',
    /** 通信手段：MCA無線 */
    CODE_MCA: 'mca',
    /** 通信手段：インターネット */
    CODE_NET: 'net',
    /** 通信手段：携帯電話 */
    CODE_PHONE: 'phone',
    /** 通信手段：TV会議 */
    CODE_TVCONFER: 'tvconfer',
    /** 通信手段：その他 */
    CODE_OTHER: 'other'
  },
  /**
   * 機能：inhit_site_func
   */
  INHIT_SITE_FUNC: {
    /** 機能 */
    KBN: 'inhit_site_func',
    /** 機能：本社（スタフ） */
    CODE_F01: 'f01',
    /** 機能：営業・開発・ＳＥ */
    CODE_F02: 'f02',
    /** 機能：製造 */
    CODE_F03: 'f03',
    /** 機能：保守 */
    CODE_F04: 'f04',
    /** 機能：倉庫 */
    CODE_F05: 'f05',
    /** 機能：その他 */
    CODE_F99: 'f99'
  },
  /**
   * 拠点種類コード：inhit_site_type_cd
   */
  INHIT_SITE_TYPE_CD: {
    /** 拠点種類コード */
    KBN: 'inhit_site_type_cd',
    /** 拠点種類コード：本社・事業場・研究所 */
    CODE_1: '1',
    /** 拠点種類コード：本社 */
    CODE_2: '2',
    /** 拠点種類コード：生産拠点 */
    CODE_3: '3',
    /** 拠点種類コード：支社・支店 */
    CODE_4: '4',
    /** 拠点種類コード：PJルーム */
    CODE_5: '5',
    /** 拠点種類コード：その他 */
    CODE_9: '9'
  },
  /**
   * 購入先重点区分：inhit_supplier_main_kbn
   */
  INHIT_SUPPLIER_MAIN_KBN: {
    /** 購入先重点区分 */
    KBN: 'inhit_supplier_main_kbn',
    /** 購入先重点区分：Ｓ */
    CODE_010: '010',
    /** 購入先重点区分：Ａ */
    CODE_020: '020',
    /** 購入先重点区分：Ｂ */
    CODE_030: '030'
  },
  /**
   * 購入先拠点区分：inhit_supplier_site_kbn
   */
  INHIT_SUPPLIER_SITE_KBN: {
    /** 購入先拠点区分 */
    KBN: 'inhit_supplier_site_kbn',
    /** 購入先拠点区分：生産拠点 */
    CODE_010: '010',
    /** 購入先拠点区分：物流拠点 */
    CODE_020: '020',
    /** 購入先拠点区分：ソフト開発拠点 */
    CODE_030: '030',
    /** 購入先拠点区分：データセンタ */
    CODE_040: '040',
    /** 購入先拠点区分：本社機能のみ */
    CODE_050: '050',
    /** 購入先拠点区分：その他 */
    CODE_060: '060'
  },
  /**
   * 監査回答状況：kansa_ans_sts
   */
  KANSA_ANS_STS: {
    /** 監査回答状況 */
    KBN: 'kansa_ans_sts',
    /** 監査回答状況：全て */
    CODE_0: '0',
    /** 監査回答状況：未回答 */
    CODE_1: '1',
    /** 監査回答状況：回答中 */
    CODE_2: '2',
    /** 監査回答状況：回答済 */
    CODE_3: '3'
  },
  /**
   * 業務内容コード：kansa_gyomu_cd
   */
  KANSA_GYOMU_CD: {
    /** 業務内容コード */
    KBN: 'kansa_gyomu_cd',
    /** 業務内容コード：監査部門 */
    CODE_1: '1',
    /** 業務内容コード：被監査部門 */
    CODE_2: '2'
  },
  /**
   * 発見事項分類コード：kansa_hkn_bnr
   */
  KANSA_HKN_BNR: {
    /** 発見事項分類コード */
    KBN: 'kansa_hkn_bnr',
    /** 発見事項分類コード：特記事項無し */
    CODE_0: '0',
    /** 発見事項分類コード：グッドポイント */
    CODE_5: '5',
    /** 発見事項分類コード：改善の機会（推奨） */
    CODE_4: '4',
    /** 発見事項分類コード：改善の機会（観察） */
    CODE_3: '3',
    /** 発見事項分類コード：不適合（軽微） */
    CODE_2: '2',
    /** 発見事項分類コード：不適合（重大） */
    CODE_1: '1'
  },
  /**
   * 被監査部門責任者評価評価状況：kansa_hyoka_sts
   */
  KANSA_HYOKA_STS: {
    /** 被監査部門責任者評価評価状況 */
    KBN: 'kansa_hyoka_sts',
    /** 被監査部門責任者評価評価状況：全て */
    CODE_0: '0',
    /** 被監査部門責任者評価評価状況：未評価 */
    CODE_1: '1',
    /** 被監査部門責任者評価評価状況：評価中 */
    CODE_2: '2',
    /** 被監査部門責任者評価評価状況：評価完了 */
    CODE_3: '3'
  },
  /**
   * 確認結果コード：kansa_kknn_rslt
   */
  KANSA_KKNN_RSLT: {
    /** 確認結果コード */
    KBN: 'kansa_kknn_rslt',
    /** 確認結果コード：はい */
    CODE_1: '1',
    /** 確認結果コード：いいえ */
    CODE_2: '2'
  },
  /**
   * 指摘事項改善計画状況：kansa_kzpln_sts
   */
  KANSA_KZPLN_STS: {
    /** 指摘事項改善計画状況 */
    KBN: 'kansa_kzpln_sts',
    /** 指摘事項改善計画状況：全て */
    CODE_4: '4',
    /** 指摘事項改善計画状況：指摘事項無し */
    CODE_0: '0',
    /** 指摘事項改善計画状況：未作成 */
    CODE_1: '1',
    /** 指摘事項改善計画状況：作成中 */
    CODE_2: '2',
    /** 指摘事項改善計画状況：作成完了 */
    CODE_3: '3'
  },
  /**
   * 指摘事項改善進捗状況：kansa_kzprg_sts
   */
  KANSA_KZPRG_STS: {
    /** 指摘事項改善進捗状況 */
    KBN: 'kansa_kzprg_sts',
    /** 指摘事項改善進捗状況：全て */
    CODE_4: '4',
    /** 指摘事項改善進捗状況：指摘事項無し */
    CODE_0: '0',
    /** 指摘事項改善進捗状況：未対応 */
    CODE_1: '1',
    /** 指摘事項改善進捗状況：対応中 */
    CODE_2: '2',
    /** 指摘事項改善進捗状況：対応完了 */
    CODE_3: '3'
  },
  /**
   * 成熟度評価サマリ区分：kansa_me_sumkbn
   */
  KANSA_ME_SUMKBN: {
    /** 成熟度評価サマリ区分 */
    KBN: 'kansa_me_sumkbn',
    /** 成熟度評価サマリ区分：今年度 */
    CODE_1: '1',
    /** 成熟度評価サマリ区分：前年度 */
    CODE_2: '2',
    /** 成熟度評価サマリ区分：自社の平均 */
    CODE_3: '3'
  },
  /**
   * （監査報告書）作成状況：kansa_rp_crests
   */
  KANSA_RP_CRESTS: {
    /** （監査報告書）作成状況 */
    KBN: 'kansa_rp_crests',
    /** （監査報告書）作成状況：全て */
    CODE_0: '0',
    /** （監査報告書）作成状況：未作成 */
    CODE_1: '1',
    /** （監査報告書）作成状況：作成中 */
    CODE_2: '2',
    /** （監査報告書）作成状況：作成完了 */
    CODE_3: '3'
  },
  /**
   * （監査報告書）評価状況：kansa_rp_evsts
   */
  KANSA_RP_EVSTS: {
    /** （監査報告書）評価状況 */
    KBN: 'kansa_rp_evsts',
    /** （監査報告書）評価状況：全て */
    CODE_0: '0',
    /** （監査報告書）評価状況：未評価 */
    CODE_1: '1',
    /** （監査報告書）評価状況：評価中 */
    CODE_2: '2',
    /** （監査報告書）評価状況：評価完了 */
    CODE_3: '3'
  },
  /**
   * 監査結果作成状況：kansa_rslt_sts
   */
  KANSA_RSLT_STS: {
    /** 監査結果作成状況 */
    KBN: 'kansa_rslt_sts',
    /** 監査結果作成状況：全て */
    CODE_0: '0',
    /** 監査結果作成状況：未作成 */
    CODE_1: '1',
    /** 監査結果作成状況：作成中 */
    CODE_2: '2',
    /** 監査結果作成状況：作成完了 */
    CODE_3: '3'
  },
  /**
   * 総合評価：kansa_sogohyoka
   */
  KANSA_SOGOHYOKA: {
    /** 総合評価 */
    KBN: 'kansa_sogohyoka',
    /** 総合評価：適合 */
    CODE_1: '1',
    /** 総合評価：不適合 */
    CODE_2: '2'
  },
  /**
   * 指摘事項区分コード：kansa_stk_kbn
   */
  KANSA_STK_KBN: {
    /** 指摘事項区分コード */
    KBN: 'kansa_stk_kbn',
    /** 指摘事項区分コード：指摘無 */
    CODE_0: '0',
    /** 指摘事項区分コード：フォローアップ */
    CODE_1: '1',
    /** 指摘事項区分コード：不適合 */
    CODE_2: '2',
    /** 指摘事項区分コード：改善の機会 */
    CODE_3: '3',
    /** 指摘事項区分コード：グッドポイント */
    CODE_4: '4'
  },
  /**
   * 監査状況：kansa_sts
   */
  KANSA_STS: {
    /** 監査状況 */
    KBN: 'kansa_sts',
    /** 監査状況：全て */
    CODE_0: '0',
    /** 監査状況：未完了 */
    CODE_1: '1',
    /** 監査状況：完了 */
    CODE_2: '2'
  },
  /**
   * 担当区分：kansa_tanto_kbn
   */
  KANSA_TANTO_KBN: {
    /** 担当区分 */
    KBN: 'kansa_tanto_kbn',
    /** 担当区分：監査部門責任者 */
    CODE_1: '1',
    /** 担当区分：監査部門担当者 */
    CODE_2: '2',
    /** 担当区分：被監査部門責任者 */
    CODE_3: '3',
    /** 担当区分：被監査部門担当者 */
    CODE_4: '4'
  },
  /**
   * 内部監査利用権限：kansa_usage
   */
  KANSA_USAGE: {
    /** 内部監査利用権限 */
    KBN: 'kansa_usage',
    /** 内部監査利用権限：システム管理者権限 */
    CODE_ALLUSEPERMISSION: 'allusepermission',
    /** 内部監査利用権限：事務局権限 */
    CODE_LIMITEDUSEPERMISSION: 'limitedusepermission'
  },
  /**
   * 災害種別コード：kbn_disaster_kind
   */
  KBN_DISASTER_KIND: {
    /** 災害種別コード */
    KBN: 'kbn_disaster_kind',
    /** 災害種別コード：地震 */
    CODE_10: '10',
    /** 災害種別コード：その他 */
    CODE_90: '90'
  },
  /**
   * 重点区分コード：kbn_supplier_main_kbn
   */
  KBN_SUPPLIER_MAIN_KBN: {
    /** 重点区分コード */
    KBN: 'kbn_supplier_main_kbn',
    /** 重点区分コード：S */
    CODE_010: '010',
    /** 重点区分コード：A */
    CODE_020: '020',
    /** 重点区分コード：B */
    CODE_030: '030'
  },
  /**
   * 都道府県コード：kbn_tdfk
   */
  KBN_TDFK: {
    /** 都道府県コード */
    KBN: 'kbn_tdfk',
    /** 都道府県コード：北海道 */
    CODE_01: '01',
    /** 都道府県コード：青森県 */
    CODE_02: '02',
    /** 都道府県コード：岩手県 */
    CODE_03: '03',
    /** 都道府県コード：宮城県 */
    CODE_04: '04',
    /** 都道府県コード：秋田県 */
    CODE_05: '05',
    /** 都道府県コード：山形県 */
    CODE_06: '06',
    /** 都道府県コード：福島県 */
    CODE_07: '07',
    /** 都道府県コード：茨城県 */
    CODE_08: '08',
    /** 都道府県コード：栃木県 */
    CODE_09: '09',
    /** 都道府県コード：群馬県 */
    CODE_10: '10',
    /** 都道府県コード：埼玉県 */
    CODE_11: '11',
    /** 都道府県コード：千葉県 */
    CODE_12: '12',
    /** 都道府県コード：東京都 */
    CODE_13: '13',
    /** 都道府県コード：神奈川県 */
    CODE_14: '14',
    /** 都道府県コード：新潟県 */
    CODE_15: '15',
    /** 都道府県コード：富山県 */
    CODE_16: '16',
    /** 都道府県コード：石川県 */
    CODE_17: '17',
    /** 都道府県コード：福井県 */
    CODE_18: '18',
    /** 都道府県コード：山梨県 */
    CODE_19: '19',
    /** 都道府県コード：長野県 */
    CODE_20: '20',
    /** 都道府県コード：岐阜県 */
    CODE_21: '21',
    /** 都道府県コード：静岡県 */
    CODE_22: '22',
    /** 都道府県コード：愛知県 */
    CODE_23: '23',
    /** 都道府県コード：三重県 */
    CODE_24: '24',
    /** 都道府県コード：滋賀県 */
    CODE_25: '25',
    /** 都道府県コード：京都府 */
    CODE_26: '26',
    /** 都道府県コード：大阪府 */
    CODE_27: '27',
    /** 都道府県コード：兵庫県 */
    CODE_28: '28',
    /** 都道府県コード：奈良県 */
    CODE_29: '29',
    /** 都道府県コード：和歌山県 */
    CODE_30: '30',
    /** 都道府県コード：鳥取県 */
    CODE_31: '31',
    /** 都道府県コード：島根県 */
    CODE_32: '32',
    /** 都道府県コード：岡山県 */
    CODE_33: '33',
    /** 都道府県コード：広島県 */
    CODE_34: '34',
    /** 都道府県コード：山口県 */
    CODE_35: '35',
    /** 都道府県コード：徳島県 */
    CODE_36: '36',
    /** 都道府県コード：香川県 */
    CODE_37: '37',
    /** 都道府県コード：愛媛県 */
    CODE_38: '38',
    /** 都道府県コード：高知県 */
    CODE_39: '39',
    /** 都道府県コード：福岡県 */
    CODE_40: '40',
    /** 都道府県コード：佐賀県 */
    CODE_41: '41',
    /** 都道府県コード：長崎県 */
    CODE_42: '42',
    /** 都道府県コード：熊本県 */
    CODE_43: '43',
    /** 都道府県コード：大分県 */
    CODE_44: '44',
    /** 都道府県コード：宮崎県 */
    CODE_45: '45',
    /** 都道府県コード：鹿児島県 */
    CODE_46: '46',
    /** 都道府県コード：沖縄県 */
    CODE_47: '47'
  },
  /**
   * 休職者フラグ：kyushoku_flg
   */
  KYUSHOKU_FLG: {
    /** 休職者フラグ */
    KBN: 'kyushoku_flg',
    /** 休職者フラグ：休職者ではない */
    CODE_0: '0',
    /** 休職者フラグ：休職者 */
    CODE_1: '1'
  },
  /**
   * 言語情報：locale
   */
  LOCALE: {
    /** 言語情報 */
    KBN: 'locale',
    /** 言語情報：日本語 */
    CODE_JA: 'ja',
    /** 言語情報：English */
    CODE_EN: 'en'
  },
  /**
   * マスタ種類：master_kind
   */
  MASTER_KIND: {
    /** マスタ種類 */
    KBN: 'master_kind',
    /** マスタ種類：会社マスタ */
    CODE_0: '0',
    /** マスタ種類：組織マスタ */
    CODE_1: '1',
    /** マスタ種類：社員マスタ */
    CODE_2: '2'
  },
  /**
   * 月：months
   */
  MONTHS: {
    /** 月 */
    KBN: 'months',
    /** 月：01 */
    CODE_1: '1',
    /** 月：02 */
    CODE_2: '2',
    /** 月：03 */
    CODE_3: '3',
    /** 月：04 */
    CODE_4: '4',
    /** 月：05 */
    CODE_5: '5',
    /** 月：06 */
    CODE_6: '6',
    /** 月：07 */
    CODE_7: '7',
    /** 月：08 */
    CODE_8: '8',
    /** 月：09 */
    CODE_9: '9',
    /** 月：10 */
    CODE_10: '10',
    /** 月：11 */
    CODE_11: '11',
    /** 月：12 */
    CODE_12: '12'
  },
  /**
   * 属性：pande_attribute
   */
  PANDE_ATTRIBUTE: {
    /** 属性 */
    KBN: 'pande_attribute',
    /** 属性：社員 */
    CODE_1: '1',
    /** 属性：派遣 */
    CODE_2: '2',
    /** 属性：請負 */
    CODE_3: '3'
  },
  /**
   * 利用権限コード：pande_auth_cd
   */
  PANDE_AUTH_CD: {
    /** 利用権限コード */
    KBN: 'pande_auth_cd',
    /** 利用権限コード：全社 */
    CODE_1: '1',
    /** 利用権限コード：会社指定 */
    CODE_2: '2',
    /** 利用権限コード：会社／組織指定 */
    CODE_3: '3',
    /** 利用権限コード：拠点指定 */
    CODE_4: '4',
    /** 利用権限コード：都道府県指定 */
    CODE_5: '5',
    /** 利用権限コード：属性：1 */
    ATTR_1: '1',
    /** 利用権限コード：属性：0 */
    ATTR_0: '0'
  },
  /**
   * 連絡可否：pande_contact
   */
  PANDE_CONTACT: {
    /** 連絡可否 */
    KBN: 'pande_contact',
    /** 連絡可否：否 */
    CODE_0: '0',
    /** 連絡可否：可 */
    CODE_1: '1'
  },
  /**
   * 感染症有無項目：pande_existence
   */
  PANDE_EXISTENCE: {
    /** 感染症有無項目 */
    KBN: 'pande_existence',
    /** 感染症有無項目：無し */
    CODE_0: '0',
    /** 感染症有無項目：有り */
    CODE_1: '1'
  },
  /**
   * ファイル種別：pande_file_type
   */
  PANDE_FILE_TYPE: {
    /** ファイル種別 */
    KBN: 'pande_file_type',
    /** ファイル種別：座席表（マスク） */
    CODE_2: '2',
    /** ファイル種別：その他 */
    CODE_3: '3'
  },
  /**
   * メールテンプレート用濃厚接触者指定有無コード：pande_mail_closecontact_cd
   */
  PANDE_MAIL_CLOSECONTACT_CD: {
    /** メールテンプレート用濃厚接触者指定有無コード */
    KBN: 'pande_mail_closecontact_cd',
    /** メールテンプレート用濃厚接触者指定有無コード：確認中／無し */
    CODE_NOT1: 'not1',
    /** メールテンプレート用濃厚接触者指定有無コード：有り */
    CODE_1: '1'
  },
  /**
   * メールテンプレート用濃厚接触可能性者有無コード：pande_mail_closecontact_umu_cd
   */
  PANDE_MAIL_CLOSECONTACT_UMU_CD: {
    /** メールテンプレート用濃厚接触可能性者有無コード */
    KBN: 'pande_mail_closecontact_umu_cd',
    /** メールテンプレート用濃厚接触可能性者有無コード：無しのみ */
    CODE_0: '0',
    /** メールテンプレート用濃厚接触可能性者有無コード：確認中／有りが一つ以上 */
    CODE_1: '1'
  },
  /**
   * メールテンプレート用報告対象者の状態コード：pande_mail_report_status_cd
   */
  PANDE_MAIL_REPORT_STATUS_CD: {
    /** メールテンプレート用報告対象者の状態コード */
    KBN: 'pande_mail_report_status_cd',
    /** メールテンプレート用報告対象者の状態コード：療養終了・死亡以外 */
    CODE_NOT4NOT7: 'not4not7',
    /** メールテンプレート用報告対象者の状態コード：療養終了 */
    CODE_4: '4',
    /** メールテンプレート用報告対象者の状態コード：健康観察終了以外 */
    CODE_NOT6: 'not6',
    /** メールテンプレート用報告対象者の状態コード：健康観察終了 */
    CODE_6: '6',
    /** メールテンプレート用報告対象者の状態コード：療養終了・健康観察終了・死亡以外 */
    CODE_NOT4NOT6NOT7: 'not4not6not7',
    /** メールテンプレート用報告対象者の状態コード：死亡 */
    CODE_7: '7'
  },
  /**
   * メール送信状態区分：pande_mail_send_kbn
   */
  PANDE_MAIL_SEND_KBN: {
    /** メール送信状態区分 */
    KBN: 'pande_mail_send_kbn',
    /** メール送信状態区分：未送信 */
    CODE_10: '10',
    /** メール送信状態区分：送信済み */
    CODE_20: '20'
  },
  /**
   * メール宛先区分：pande_mail_send_section
   */
  PANDE_MAIL_SEND_SECTION: {
    /** メール宛先区分 */
    KBN: 'pande_mail_send_section',
    /** メール宛先区分：TO */
    CODE_1: '1',
    /** メール宛先区分：CC */
    CODE_2: '2'
  },
  /**
   * メールテンプレート番号：pande_mail_template_no
   */
  PANDE_MAIL_TEMPLATE_NO: {
    /** メールテンプレート番号 */
    KBN: 'pande_mail_template_no',
    /** メールテンプレート番号：テンプレート番号98 */
    CODE_98: '98',
    /** メールテンプレート番号：テンプレート番号99 */
    CODE_99: '99'
  },
  /**
   * NECg内外：pande_necg
   */
  PANDE_NECG: {
    /** NECg内外 */
    KBN: 'pande_necg',
    /** NECg内外：NECg内 */
    CODE_1: '1',
    /** NECg内外：NECg外 */
    CODE_2: '2'
  },
  /**
   * 検査結果報告状況：pande_report_cd
   */
  PANDE_REPORT_CD: {
    /** 検査結果報告状況 */
    KBN: 'pande_report_cd',
    /** 検査結果報告状況：未報告 */
    CODE_0: '0',
    /** 検査結果報告状況：報告済 */
    CODE_1: '1'
  },
  /**
   * 報告終了フラグ：pande_report_end_flg
   */
  PANDE_REPORT_END_FLG: {
    /** 報告終了フラグ */
    KBN: 'pande_report_end_flg',
    /** 報告終了フラグ：報告中 */
    CODE_0: '0',
    /** 報告終了フラグ：報告終了 */
    CODE_1: '1'
  },
  /**
   * 検査結果：pande_report_kensa_rst
   */
  PANDE_REPORT_KENSA_RST: {
    /** 検査結果 */
    KBN: 'pande_report_kensa_rst',
    /** 検査結果：未実施 */
    CODE_0: '0',
    /** 検査結果：検査中 */
    CODE_1: '1',
    /** 検査結果：陽性 */
    CODE_2: '2',
    /** 検査結果：陰性 */
    CODE_3: '3',
    /** 検査結果：属性：0 */
    ATTR_0: '0',
    /** 検査結果：属性：1 */
    ATTR_1: '1',
    /** 検査結果：属性：2 */
    ATTR_2: '2'
  },
  /**
   * 報告対象者の状態：pande_report_status
   */
  PANDE_REPORT_STATUS: {
    /** 報告対象者の状態 */
    KBN: 'pande_report_status',
    /** 報告対象者の状態：検査を受けることが決まった、または受けた */
    CODE_1: '1',
    /** 報告対象者の状態：保健所から濃厚接触者に指定された */
    CODE_5: '5',
    /** 報告対象者の状態：検査結果の通知を受けた */
    CODE_2: '2',
    /** 報告対象者の状態：検査結果陽性で、治療方針が決定した */
    CODE_3: '3',
    /** 報告対象者の状態：医師の判断で療養終了し、出社可能となった（陽性者） */
    CODE_4: '4',
    /** 報告対象者の状態：健康観察終了し、出社可能となった（濃厚接触者） */
    CODE_6: '6',
    /** 報告対象者の状態：新型コロナウイルスを原因として亡くなった */
    CODE_7: '7'
  },
  /**
   * 一覧用報告対象者の状態：pande_report_status_list
   */
  PANDE_REPORT_STATUS_LIST: {
    /** 一覧用報告対象者の状態 */
    KBN: 'pande_report_status_list',
    /** 一覧用報告対象者の状態：検査実施決定 */
    CODE_1: '1',
    /** 一覧用報告対象者の状態：濃厚接触者指定 */
    CODE_5: '5',
    /** 一覧用報告対象者の状態：検査結果判明 */
    CODE_2: '2',
    /** 一覧用報告対象者の状態：療養内容報告 */
    CODE_3: '3',
    /** 一覧用報告対象者の状態：療養終了 */
    CODE_4: '4',
    /** 一覧用報告対象者の状態：健康観察終了 */
    CODE_6: '6',
    /** 一覧用報告対象者の状態：死亡 */
    CODE_7: '7'
  },
  /**
   * 座席間隔：pande_seat_spacing
   */
  PANDE_SEAT_SPACING: {
    /** 座席間隔 */
    KBN: 'pande_seat_spacing',
    /** 座席間隔：1m内 */
    CODE_1: '1',
    /** 座席間隔：1m外 */
    CODE_2: '2'
  },
  /**
   * 重症項目：pande_serious
   */
  PANDE_SERIOUS: {
    /** 重症項目 */
    KBN: 'pande_serious',
    /** 重症項目：重症以外 */
    CODE_0: '0',
    /** 重症項目：重症 */
    CODE_1: '1'
  },
  /**
   * 性別：pande_sex
   */
  PANDE_SEX: {
    /** 性別 */
    KBN: 'pande_sex',
    /** 性別：男性 */
    CODE_1: '1',
    /** 性別：女性 */
    CODE_2: '2'
  },
  /**
   * 集計用属性：pande_tot_attribute
   */
  PANDE_TOT_ATTRIBUTE: {
    /** 集計用属性 */
    KBN: 'pande_tot_attribute',
    /** 集計用属性：全て */
    CODE_1: '1',
    /** 集計用属性：社員 */
    CODE_2: '2',
    /** 集計用属性：派遣・請負 */
    CODE_3: '3'
  },
  /**
   * 治療方針：pande_treatments_policy
   */
  PANDE_TREATMENTS_POLICY: {
    /** 治療方針 */
    KBN: 'pande_treatments_policy',
    /** 治療方針：入院 */
    CODE_1: '1',
    /** 治療方針：ホテル療養 */
    CODE_2: '2',
    /** 治療方針：自宅療養 */
    CODE_3: '3'
  },
  /**
   * 感染症要否項目：pande_yohi
   */
  PANDE_YOHI: {
    /** 感染症要否項目 */
    KBN: 'pande_yohi',
    /** 感染症要否項目：要 */
    CODE_1: '1',
    /** 感染症要否項目：否 */
    CODE_0: '0'
  },
  /**
   * 社員識別コード：shain_skb_cd
   */
  SHAIN_SKB_CD: {
    /** 社員識別コード */
    KBN: 'shain_skb_cd',
    /** 社員識別コード：社員 */
    CODE_0: '0',
    /** 社員識別コード：構内作業者 */
    CODE_1: '1',
    /** 社員識別コード：外部接続者 */
    CODE_2: '2'
  },
  /**
   * 職位分類：shokui_bunrui
   */
  SHOKUI_BUNRUI: {
    /** 職位分類 */
    KBN: 'shokui_bunrui',
    /** 職位分類：役員 */
    CODE_0: '0',
    /** 職位分類：管理職 */
    CODE_1: '1',
    /** 職位分類：主任 */
    CODE_2: '2',
    /** 職位分類：担当 */
    CODE_3: '3'
  },
  /**
   * 出向者コード：shukko_cd
   */
  SHUKKO_CD: {
    /** 出向者コード */
    KBN: 'shukko_cd',
    /** 出向者コード：自社在籍 */
    CODE_0: '0',
    /** 出向者コード：国内法人出向 */
    CODE_1: '1',
    /** 出向者コード：海外法人出向 */
    CODE_2: '2'
  },
  /**
   * 管理サイト種別コード：site_kind_cd
   */
  SITE_KIND_CD: {
    /** 管理サイト種別コード */
    KBN: 'site_kind_cd',
    /** 管理サイト種別コード：自然災害 */
    CODE_EQ: 'EQ',
    /** 管理サイト種別コード：訓練 */
    CODE_KR: 'KR',
    /** 管理サイト種別コード：発動後レビュー */
    CODE_RH: 'RH',
    /** 管理サイト種別コード：お問い合わせ */
    CODE_00: '00',
    /** 管理サイト種別コード：属性：1 */
    ATTR_1: '1',
    /** 管理サイト種別コード：属性：0 */
    ATTR_0: '0'
  },
  /**
   * ソート順：sort_order
   */
  SORT_ORDER: {
    /** ソート順 */
    KBN: 'sort_order',
    /** ソート順：昇順 */
    CODE_ASC: 'ASC',
    /** ソート順：降順 */
    CODE_DESC: 'DESC'
  },
  /**
   * 購入先リストメール送信区分：suplist_mail_send_kbn
   */
  SUPLIST_MAIL_SEND_KBN: {
    /** 購入先リストメール送信区分 */
    KBN: 'suplist_mail_send_kbn',
    /** 購入先リストメール送信区分：自動送信 */
    CODE_10: '10',
    /** 購入先リストメール送信区分：送信しない */
    CODE_30: '30'
  },
  /**
   * 購入先リストメール送信状態：suplist_mail_send_status
   */
  SUPLIST_MAIL_SEND_STATUS: {
    /** 購入先リストメール送信状態 */
    KBN: 'suplist_mail_send_status',
    /** 購入先リストメール送信状態：未送信 */
    CODE_10: '10',
    /** 購入先リストメール送信状態：送信準備中 */
    CODE_20: '20',
    /** 購入先リストメール送信状態：送信済み */
    CODE_30: '30',
    /** 購入先リストメール送信状態：送信エラー */
    CODE_90: '90'
  },
  /**
   * 都道府県：tdfk
   */
  TDFK: {
    /** 都道府県 */
    KBN: 'tdfk',
    /** 都道府県：北海道 */
    CODE_01: '01',
    /** 都道府県：青森県 */
    CODE_02: '02',
    /** 都道府県：岩手県 */
    CODE_03: '03',
    /** 都道府県：宮城県 */
    CODE_04: '04',
    /** 都道府県：秋田県 */
    CODE_05: '05',
    /** 都道府県：山形県 */
    CODE_06: '06',
    /** 都道府県：福島県 */
    CODE_07: '07',
    /** 都道府県：茨城県 */
    CODE_08: '08',
    /** 都道府県：栃木県 */
    CODE_09: '09',
    /** 都道府県：群馬県 */
    CODE_10: '10',
    /** 都道府県：埼玉県 */
    CODE_11: '11',
    /** 都道府県：千葉県 */
    CODE_12: '12',
    /** 都道府県：東京都 */
    CODE_13: '13',
    /** 都道府県：神奈川県 */
    CODE_14: '14',
    /** 都道府県：新潟県 */
    CODE_15: '15',
    /** 都道府県：富山県 */
    CODE_16: '16',
    /** 都道府県：石川県 */
    CODE_17: '17',
    /** 都道府県：福井県 */
    CODE_18: '18',
    /** 都道府県：山梨県 */
    CODE_19: '19',
    /** 都道府県：長野県 */
    CODE_20: '20',
    /** 都道府県：岐阜県 */
    CODE_21: '21',
    /** 都道府県：静岡県 */
    CODE_22: '22',
    /** 都道府県：愛知県 */
    CODE_23: '23',
    /** 都道府県：三重県 */
    CODE_24: '24',
    /** 都道府県：滋賀県 */
    CODE_25: '25',
    /** 都道府県：京都府 */
    CODE_26: '26',
    /** 都道府県：大阪府 */
    CODE_27: '27',
    /** 都道府県：兵庫県 */
    CODE_28: '28',
    /** 都道府県：奈良県 */
    CODE_29: '29',
    /** 都道府県：和歌山県 */
    CODE_30: '30',
    /** 都道府県：鳥取県 */
    CODE_31: '31',
    /** 都道府県：島根県 */
    CODE_32: '32',
    /** 都道府県：岡山県 */
    CODE_33: '33',
    /** 都道府県：広島県 */
    CODE_34: '34',
    /** 都道府県：山口県 */
    CODE_35: '35',
    /** 都道府県：徳島県 */
    CODE_36: '36',
    /** 都道府県：香川県 */
    CODE_37: '37',
    /** 都道府県：愛媛県 */
    CODE_38: '38',
    /** 都道府県：高知県 */
    CODE_39: '39',
    /** 都道府県：福岡県 */
    CODE_40: '40',
    /** 都道府県：佐賀県 */
    CODE_41: '41',
    /** 都道府県：長崎県 */
    CODE_42: '42',
    /** 都道府県：熊本県 */
    CODE_43: '43',
    /** 都道府県：大分県 */
    CODE_44: '44',
    /** 都道府県：宮崎県 */
    CODE_45: '45',
    /** 都道府県：鹿児島県 */
    CODE_46: '46',
    /** 都道府県：沖縄県 */
    CODE_47: '47',
    /** 都道府県：海外 */
    CODE_48: '48',
    /** 都道府県：属性：1 */
    ATTR_1: '1',
    /** 都道府県：属性：3 */
    ATTR_3: '3',
    /** 都道府県：属性：2 */
    ATTR_2: '2',
    /** 都道府県：属性：5 */
    ATTR_5: '5',
    /** 都道府県：属性：4 */
    ATTR_4: '4',
    /** 都道府県：属性：6 */
    ATTR_6: '6',
    /** 都道府県：属性：7 */
    ATTR_7: '7',
    /** 都道府県：属性：8 */
    ATTR_8: '8',
    /** 都道府県：属性：9 */
    ATTR_9: '9',
    /** 都道府県：属性：0 */
    ATTR_0: '0'
  },
  /**
   * 地方コード：tdfk_region
   */
  TDFK_REGION: {
    /** 地方コード */
    KBN: 'tdfk_region',
    /** 地方コード：北海道・東北 */
    CODE_1: '1',
    /** 地方コード：甲信越 */
    CODE_2: '2',
    /** 地方コード：関東 */
    CODE_3: '3',
    /** 地方コード：東海 */
    CODE_4: '4',
    /** 地方コード：北陸 */
    CODE_5: '5',
    /** 地方コード：近畿 */
    CODE_6: '6',
    /** 地方コード：中国 */
    CODE_7: '7',
    /** 地方コード：四国 */
    CODE_8: '8',
    /** 地方コード：九州・沖縄 */
    CODE_9: '9'
  },
  /**
   * 証跡区分コード：trailkbn_cd
   */
  TRAILKBN_CD: {
    /** 証跡区分コード */
    KBN: 'trailkbn_cd',
    /** 証跡区分コード：内部監査 */
    CODE_1: '1',
    /** 証跡区分コード：BCM */
    CODE_2: '2'
  },
  /**
   * 更新方法：update_method
   */
  UPDATE_METHOD: {
    /** 更新方法 */
    KBN: 'update_method',
    /** 更新方法：新規登録／差分更新 */
    CODE_1: '1',
    /** 更新方法：削除 */
    CODE_2: '2'
  },
  /**
   * 利用権限：usage_rights
   */
  USAGE_RIGHTS: {
    /** 利用権限 */
    KBN: 'usage_rights',
    /** 利用権限：システム管理者権限 */
    CODE_ADMIN: 'admin',
    /** 利用権限：事務局権限 */
    CODE_SECRETARIAT: 'secretariat',
    /** 利用権限：対策本部権限 */
    CODE_HEADQUARTER: 'headquarter',
    /** 利用権限：一般利用者権限 */
    CODE_GENERAL: 'general'
  },
  /**
   * 警報情報自動取込ステータス：warning_auto_import_status
   */
  WARNING_AUTO_IMPORT_STATUS: {
    /** 警報情報自動取込ステータス */
    KBN: 'warning_auto_import_status',
    /** 警報情報自動取込ステータス：自動登録中 */
    CODE_1: '1',
    /** 警報情報自動取込ステータス：自動登録終了 */
    CODE_2: '2'
  },
  /**
   * 気象警報警戒レベル：weather_warning_lv
   */
  WEATHER_WARNING_LV: {
    /** 気象警報警戒レベル */
    KBN: 'weather_warning_lv',
    /** 気象警報警戒レベル：特別警報 */
    CODE_01: '01',
    /** 気象警報警戒レベル：警報 */
    CODE_02: '02',
    /** 気象警報警戒レベル：注意報 */
    CODE_03: '03'
  }
};